import FoodCategory from '@components/offer/models/FoodCategory';
import { Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodCategoryBaseButton from './FoodCategoryBaseButton';

interface FoodCategoryListItemProps {
    foodCategory: FoodCategory;
    onClick: (foodCategory: FoodCategory) => void
}

const FoodCategoryListItem: React.FC<FoodCategoryListItemProps> = observer(({ foodCategory, onClick }) => {
    return (
        <FoodCategoryBaseButton foodCategory={foodCategory} onClick={onClick}>
            <Grid padding={1.5} container direction="column" justifyContent="center" alignItems="center">
                <img
                    src={require(`../../../../../assets/offer/food-category/${foodCategory.iconName}.png`)}
                    height={32} />
                <Typography
                    fontWeight={600}
                    variant='subtitle2'
                    mt={1}>
                    {foodCategory.name}
                </Typography>
            </Grid>
        </FoodCategoryBaseButton>
    )
})

export default FoodCategoryListItem;